import React from 'react';
import './NewFooterV2.scss';
import { redirectWithCookies } from '../../utils/Utm'
import Picture from '../../components/Picture'

export default function NewFooter() {
    const accessLinks = [
        { name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true },
        { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }
    ];

    const footerRows = [
        [
            {
                title: 'Soluções',
                links: [
                    { name: 'Força de vendas', url: '/forca-vendas/' },
                    { name: 'E-commerce B2B', url: '/e-commerce-b2b/' },
                    { name: 'CRM', url: '/crm-de-vendas' },
                    { name: 'Mercos Pay', url: '/mercos-pay' },
                    { name: 'Videochamada', url: '/videochamada/' }
                ]
            },
            {
                title: 'Recursos',
                links: [
                    { name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' },
                    { name: 'Indicadores de vendas', url: '/recursos/indicadores-performance/' },
                    { name: 'Políticas comerciais', url: '/recursos/politica-comercial-vendas/' },
                    { name: 'Mercos IA', url: '/recursos/mercos-ia/' }
                ]
            },
            {
                title: 'Conteúdo',
                links: [
                    { name: 'Blog', url: 'https://blog.mercos.com/', external: true },
                    { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI', external: true },
                    { name: <React.Fragment>E-commerce B2B: O<br />que é?</React.Fragment>, url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank', external: true }
                ]
            },
            {
                title: 'Transparência',
                links: [
                    { name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' },
                    { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' },
                    { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank', external: true },
                    { name: 'Relatório da igualdade salarial', url: '/relatorio-igualdade-salarial/' }
                ]
            },
            {
                title: 'Suporte',
                links: [
                    { name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', external: true },
                    {
                        custom: true,
                        content: (
                            <div className="support-info">
                                <div className="support-phone">(47) 3481.8050</div>
                                <div className="support-hours">
                                    Atendimento de Segunda<br />
                                    a Quinta das 9h às 17h.<br />
                                    Sexta das 9h30 às 17h.
                                </div>
                            </div>
                        )
                    }
                ]
            }
        ],
        [
            {
                title: 'Segmentos',
                links: [
                    { name: 'Indústrias', url: '/industrias/' },
                    { name: 'Distribuidoras', url: '/distribuidoras/' },
                    { name: 'Representantes', url: '/representantes-comerciais/' }
                ]
            },
            {
                title: 'Planos e preços',
                links: [
                    { name: 'Indústrias e distribuidoras', url: '/planos-e-precos/industrias-e-distribuidoras/' },
                    { name: 'Representantes', url: '/planos-e-precos/representantes/' }
                ]
            },
            {
                title: 'Institucional',
                links: [
                    { name: 'Carreira', url: 'https://mercos.gupy.io/' },
                    { name: 'Sobre Nós', url: '/sobre/' }
                ]
            },
            {
                title: 'Integrações',
                links: [
                    { name: 'ERPs integrados', url: '/integracao-erp/' },
                    { name: 'Seja Parceiro', url: '/parceiros' },
                    { name: 'Documentação da API', url: 'https://docs.mercos.com/', external: true }
                ]
            },
            {
                title: 'Baixe o aplicativo',
                content: (
                    <React.Fragment>
                        <div className="app-buttons">
                            <a href="https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628" target="_blank" rel="noopener noreferrer" className="app-button">
                                <Picture loading="lazy" src="/images/site/social/app-store.png" alt="Baixar na App Store" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR" target="_blank" rel="noopener noreferrer" className="app-button">
                                <Picture loading="lazy" src="/images/site/social/google-play.png" alt="Disponível no Google Play" />
                            </a>
                        </div>
                        <p className="app-downloads"><strong>+100 mil</strong> downloads</p>
                    </React.Fragment>
                )
            }
        ]
    ];

    const renderLink = (link, className = 'footer-link') => {
        if (link.custom) return link.content;
        const target = link.target || (link.external ? '_blank' : null);

        return (
            <a
                className={className}
                href={link.redirect ? null : link.url}
                onClick={link.redirect ? () => redirectWithCookies(link.url) : null}
                target={target}
                rel={target === '_blank' ? 'noopener noreferrer' : null}
            >
                {link.name}
                {link.external && <span className="material-icons site-footer__external-icon" aria-hidden="true">north_east</span>}
            </a>
        );
    };

    const socialLinks = [
        { name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' },
        { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' },
        { name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' },
        { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' },
        { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }
    ];

    return (
        <footer className="mercos-footer site-footer" aria-label="Rodapé">
            <div className="footer-content site-footer__inner">
                <div className="site-footer__access">
                    <p className="site-footer__access-txt">Já é cliente ou quer começar?</p>
                    <div className="site-footer__access-actions">
                        {accessLinks.map((link, index) => (
                            <React.Fragment key={link.url}>
                                {renderLink(
                                    link,
                                    `site-footer__access-btn site-footer__access-btn--${index === 0 ? 'login' : 'signup'}`
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                </div>

                <nav className="footer-main site-footer__nav" aria-label="Links do rodapé">
                    {footerRows.map((row, rowIndex) => (
                        <div className="site-footer__nav-row" key={rowIndex}>
                            {row.map(section => (
                                <section className="footer-section site-footer__section" key={section.title}>
                                    <p className="section-title site-footer__col-title">{section.title}</p>
                                    {section.content || (
                                        <div className="section-links site-footer__links">
                                            {section.links.map((link, linkIndex) => (
                                                <div className="link-item" key={link.url || linkIndex}>
                                                    {renderLink(link, 'footer-link site-footer__link')}
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </section>
                            ))}
                        </div>
                    ))}
                </nav>
            </div>

            <div className="footer-bottom site-footer__bar">
                <div className="footer-container site-footer__bar-inner">
                    <div className="logo-container">
                        <a href="/" className="mercos-logo site-footer__bar-logo-link">
                            <Picture loading="lazy" src="/images/mercos-nuvini.svg" alt="Mercos - uma empresa nuvini" />
                        </a>
                    </div>

                    <div className="company-info site-footer__legal">
                        <div>© {new Date().getFullYear()} Simplest Software Ltda. Todos os direitos reservados.</div>
                        <div>CNPJ: 12.496.510/0001-80 · Av. Rolf Wiest, 277 (4º andar) · Bom Retiro — Joinville/SC · CEP: 89223-005</div>
                    </div>

                    <div className="social-links site-footer__social">
                        {socialLinks.map(social => (
                            <a
                                key={social.name}
                                href={social.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="social-link site-footer__social-link"
                                aria-label={social.name}
                            >
                                <Picture loading="lazy" src={social.icon} alt={`Mercos no ${social.name}`} />
                            </a>
                        ))}
                        <span className="feito-com-amor site-footer__made">Feito com 💜</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/NewFooter/NewFooterV2.jsx